// Converting an Apryse annotation's viewer rectangle into the PDF coordinates
// the backend sends to Formstack: x/y from getPDFCoordinates (origin
// bottom-left, y is the rectangle's top), width/height in PDF points. Shared by
// the template editor and the send window so boxes land where they are drawn.

export const roundCoordinate = (value) => Math.round(Number(value || 0) * 100) / 100;

export const getAnnotationViewerDimensions = (annotation) => {
  const width = Number(
    annotation?.Width ??
      annotation?.width ??
      (typeof annotation?.getWidth === "function" ? annotation.getWidth() : NaN)
  );
  const height = Number(
    annotation?.Height ??
      annotation?.height ??
      (typeof annotation?.getHeight === "function" ? annotation.getHeight() : NaN)
  );

  return {
    width: Number.isFinite(width) && width > 0 ? width : null,
    height: Number.isFinite(height) && height > 0 ? height : null,
  };
};

export const convertViewerRectToPdfDimensions = (
  instance,
  pageNumber,
  viewerX,
  viewerY,
  viewerWidth,
  viewerHeight
) => {
  if (
    !Number.isFinite(viewerWidth) ||
    viewerWidth <= 0 ||
    !Number.isFinite(viewerHeight) ||
    viewerHeight <= 0
  ) {
    return null;
  }

  const doc = instance?.Core?.documentViewer?.getDocument?.();
  if (typeof doc?.getPDFCoordinates !== "function") {
    return {
      width: roundCoordinate(viewerWidth),
      height: roundCoordinate(viewerHeight),
    };
  }

  const topLeft = doc.getPDFCoordinates(pageNumber, viewerX, viewerY);
  const rightPoint = doc.getPDFCoordinates(pageNumber, viewerX + viewerWidth, viewerY);
  const bottomPoint = doc.getPDFCoordinates(pageNumber, viewerX, viewerY + viewerHeight);
  const pdfWidth = Math.abs(
    Number(rightPoint?.x ?? viewerX + viewerWidth) - Number(topLeft?.x ?? viewerX)
  );
  const pdfHeight = Math.abs(
    Number(bottomPoint?.y ?? viewerY + viewerHeight) - Number(topLeft?.y ?? viewerY)
  );

  return {
    width: roundCoordinate(pdfWidth),
    height: roundCoordinate(pdfHeight),
  };
};

export const getAnnotationPdfPlacement = (instance, annotation) => {
  const pageNumber = Number(annotation?.PageNumber || annotation?.pageNumber || 1);
  const x = Number(annotation?.X ?? annotation?.x ?? 36);
  const y = Number(annotation?.Y ?? annotation?.y ?? 36);
  if (!Number.isFinite(pageNumber) || !Number.isFinite(x) || !Number.isFinite(y)) {
    return null;
  }

  const doc = instance?.Core?.documentViewer?.getDocument?.();
  const pdfPoint =
    typeof doc?.getPDFCoordinates === "function"
      ? doc.getPDFCoordinates(pageNumber, x, y)
      : { x, y };
  const viewerDimensions = getAnnotationViewerDimensions(annotation);
  const pdfDimensions =
    viewerDimensions.width && viewerDimensions.height
      ? convertViewerRectToPdfDimensions(
          instance,
          pageNumber,
          x,
          y,
          viewerDimensions.width,
          viewerDimensions.height
        )
      : null;

  return {
    page_number: pageNumber,
    x: roundCoordinate(pdfPoint?.x ?? x),
    y: roundCoordinate(pdfPoint?.y ?? y),
    ...(pdfDimensions || {}),
  };
};
